/**
 * URL sync utilities for iframe app persistent wrappers.
 * Used by PersistentCrm, PersistentRaven, PersistentInsights.
 */

/**
 * Determines whether a navigation is "significant" (push history entry)
 * or "minor" (replace current entry).
 *
 * Significant: path change (different record/page) → pushState
 * Minor: only query params or hash changed (tab switch) → replaceState
 */
export function isSignificantNavigation(prevPath: string, newPath: string): boolean {
  if (!prevPath || !newPath) return true; // First navigation is always significant
  if (prevPath === newPath) return false;

  // Strip query params and hash — compare base paths only
  const prevClean = prevPath.split('?')[0].split('#')[0];
  const newClean = newPath.split('?')[0].split('#')[0];

  if (prevClean === newClean) return false; // Only query/hash changed → minor

  // Different path segments → significant
  return true;
}
